import image1 from "../assets/t-image-1.png";
import image2 from "../assets/t-image-2.png";
import image3 from "../assets/t-image-3.png";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
    name: 'ABHISHEK SINGH',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'This gym is amazing. Amazing facility, top equipment and great environment. Good service with friendly staff ',
    name: 'SANDEEP ANAND',
    status: 'COACH'
  },
  {
    image : image3,
    review:' Good service with friendly staff and super clean and comfortable gym for everyone from beginners to professional athletes to train at.',
    name: 'ABHISHEK KUMAR',
    status: "CUSTOMER"
  }
];
